export enum ProgressType {
  waiting = 'waiting',
  processing = 'processing'
}
